import util from '../util'

let controller = 'QueueCallback'

export default Object.assign({}, util.GetCrud(controller, ['get']), {
  GetLogTentativasDisparo: function (currentQueueCallback) {
    let params = {
      Codigo: currentQueueCallback.codigo,
      OrigemTransacao: currentQueueCallback.origemTransacao,
      CodigoTransacao: currentQueueCallback.codigoTransacao,
      CodigoConta: currentQueueCallback.codigoConta
    }

    return util.Axios.Post(controller + '/GetLogTentativasDisparo', params)
  },
  GetAll (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  },
  GerarExcel (dto) {
    return util.Axios.GetAll(controller + '/GerarExcel', dto)
  }
})
